import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["gameSelect", "gameGroup"]

    onChange() {
        const select = this.gameSelectTarget.querySelector("select")

        if (this.gameGroupTarget.checked) {
            this.gameSelectTarget.classList.remove("hidden")
            select.required = true
        } else {
            this.gameSelectTarget.classList.add("hidden")
            select.required = false
            select.selectedIndex = 0
        }
    }
}
